import { createAsyncAction } from 'typesafe-actions';

import * as Types from './submitReport.actionType';
import { Report, ReportSummary } from '../../../utils/classes';

export interface SubmitReportAPI {
  report: Report;
  summary: ReportSummary | string;
  reportId: string;
  siteId: string;
  apiReportID?: string;
  callback: { resolve: Function; reject: Function };
}

export const submitApiReportAsync = createAsyncAction(
  Types.SUBMIT_REPORT_REQUEST,
  Types.SUBMIT_REPORT_SUCCESS,
  Types.SUBMIT_REPORT_FAILURE
)<SubmitReportAPI, boolean | null, string>();
